import Phaser from 'phaser';
import { CAMERA_PAN_SPEED, CAMERA_ZOOM_MIN, CAMERA_ZOOM_MAX } from '@/config';

/** Manages camera panning (WASD/arrow keys) and scroll-wheel zoom */
export class IsoCamera {
  private camera: Phaser.Cameras.Scene2D.Camera;
  private cursors: Phaser.Types.Input.Keyboard.CursorKeys | null = null;
  private wasd: { W: Phaser.Input.Keyboard.Key; A: Phaser.Input.Keyboard.Key; S: Phaser.Input.Keyboard.Key; D: Phaser.Input.Keyboard.Key } | null = null;

  constructor(scene: Phaser.Scene) {
    this.camera = scene.cameras.main;

    if (scene.input.keyboard) {
      this.cursors = scene.input.keyboard.createCursorKeys();
      this.wasd = {
        W: scene.input.keyboard.addKey(Phaser.Input.Keyboard.KeyCodes.W),
        A: scene.input.keyboard.addKey(Phaser.Input.Keyboard.KeyCodes.A),
        S: scene.input.keyboard.addKey(Phaser.Input.Keyboard.KeyCodes.S),
        D: scene.input.keyboard.addKey(Phaser.Input.Keyboard.KeyCodes.D),
      };
    }

    // Scroll zoom
    scene.input.on('wheel', (_pointer: any, _go: any, _dx: number, dy: number) => {
      const zoomDelta = dy > 0 ? -0.1 : 0.1;
      this.camera.zoom = Phaser.Math.Clamp(
        this.camera.zoom + zoomDelta,
        CAMERA_ZOOM_MIN,
        CAMERA_ZOOM_MAX
      );
    });
  }

  /** Call from scene update() */
  update(): void {
    const speed = CAMERA_PAN_SPEED / this.camera.zoom;

    const left = this.cursors?.left.isDown || this.wasd?.A.isDown;
    const right = this.cursors?.right.isDown || this.wasd?.D.isDown;
    const up = this.cursors?.up.isDown || this.wasd?.W.isDown;
    const down = this.cursors?.down.isDown || this.wasd?.S.isDown;

    if (left) this.camera.scrollX -= speed;
    if (right) this.camera.scrollX += speed;
    if (up) this.camera.scrollY -= speed;
    if (down) this.camera.scrollY += speed;
  }

  /** Center on a world position */
  centerOn(x: number, y: number): void {
    this.camera.centerOn(x, y);
  }
}
